<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <BaseForm
      ref="form"
      v-bind="form"
      class="screen__form"
      @submit="onFormSubmit"
    />
  </BaseScreen>
</template>

<script>
import { mapState } from 'vuex';
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import formMixin from '@/mixins/form';
import mailMixin from '@/mixins/mail';

import FieldEmail from '@/components/FieldEmail.vue';

export default {
  name: 'PhotoSendScreen',
  mixins: [screenMixin, formMixin, mailMixin],
  data() {
    return {
      values: {
        email: '',
      },
    };
  },
  computed: {
    ...mapState('photo', [
      'photo',
    ]),
    titleText() {
      return this.$t('titles.email');
    },
    screenCase() {
      if (this.isThanksVisible) {
        return CONSTANTS.STEP_PHOTO_SENDED;
      }
      if (this.isErrorVisible) {
        return CONSTANTS.STEP_SENDING_ERROR;
      }
      return CONSTANTS.STEP_SEND_PHOTO;
    },
    form() {
      return {
        values: this.values,
        fields: [
          {
            is: FieldEmail,
            name: 'email',
          },
        ],
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
          {
            type: 'submit',
            text: this.$t('actions.send'),
          },
        ],
      };
    },
    thanks() {
      return {
        icon: {
          name: 'success',
          theme: 'primary',
          size: 'l',
        },
        description: {
          text: `${this.$t('texts.photoWasSended')} <b>${this.values.email}</b>`,
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
          {
            text: this.$t('actions.backToPhoto'),
            action: this.goToBackScreen,
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.sendEmailFailed'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.sendPhotoNotPossible'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
  },
  created() {
    this.initActions([
      [CONSTANTS.ACTION_BACK, this.goToBackScreen],
    ]);
  },
  methods: {
    onFormSubmit() {
      if (this.isPending) return;

      this.showPending();

      const { email } = this.values;
      const subject = this.$t('titles.yourPhoto');
      const file = this.photo?.fullpath;
      const body = '';

      this.sendMail(email, subject, body, file); // функция из миксина
    },
  },
};
</script>
